var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-card',[_c('v-card-title',[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-arrow-decision-auto-outline")]),_vm._v("\n      Applications by Campaign\n      "),_c('v-spacer'),(_vm.applications.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":20,"width":1,"color":_vm.themes.client.light.input}}):_vm._e()],1),_c('v-divider'),_c('v-card-text',[(!_vm.applications.loading)?_c('apex',{attrs:{"type":"pie","width":"100%","height":400,"options":{
          labels: Object.keys(_vm.applications),
          colors: _vm.colors,
          chart: { fontFamily: 'Heebo, sans-serif', toolbar: { show: true }  },
          tooltip: { enabled: true },
          legend: { position: 'bottom' },
        },"series":Object.values(_vm.applications)}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }